import React from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Indicator } from '../../../../styled';
import { getMetricInfo } from '../../../../constants';
import { convertValue } from '../../../../shared';
import { SavedFilter } from '@src/components/filter/types';

const { baseUrl } = window.conviva;

const StyledLink = styled(Link)`
  color: black;
  font-size: 16px;
  font-weight: 300;
`;

export interface TableData {
  id: string;
  name: string;
  filter: SavedFilter;
  condition: string;
  sample: string;
  time: string;
  parentId?: number;
  children?: Array<Partial<TableData>>;
  renderer?: (props: any) => JSX.Element;
  source: any;
  expandIconRenderer?: (props: any) => JSX.Element;
  actions?: boolean;
}

export default function formatTableData(alert, eventCounts) {
  const { id: alertId, metric, filter, name, direction, samples, threshold } = alert;
  const metricsInfo = getMetricInfo();
  const metricInfo = metricsInfo[metric];
  const events = get(alert, 'events', []);
  const totalEvents = eventCounts[alertId] || events.length;
  const alertData: TableData = {
    id: `alert-${alertId}`,
    name,
    filter,
    condition: `${metricInfo.name} ${direction} ${threshold} ${metricInfo.units}`,
    sample: `${samples} ${metricInfo.cm_label}`,
    time: events.length > 0 ? events[0].time : '-',
    source: alert,
    actions: true,
  };
  alertData.children = events.map((event) => {
    const { id: eventId, value, samples, time } = event;
    return {
      id: `event-${eventId}`,
      filter,
      name,
      sample: `${samples} ${metricInfo.cm_label}`,
      parentId: alertId,
      condition: `${convertValue(value, metricInfo.units)} ${metricInfo.units}`,
      time,
      source: event,
      expandIconRenderer: ({ rowData }) => {
        const {
          source: { sent },
        } = rowData;
        return <Indicator sent={sent} />;
      },
    };
  });
  if (totalEvents && totalEvents > 5) {
    alertData.children.push({
      id: `show-more-${alertId}`,
      parentId: alertId,
      renderer: (style) => (
        <div style={style}>
          <StyledLink to={`${baseUrl}/alert/manual/events?alertId=${alertId}&page=1`}>
            See all events
          </StyledLink>
        </div>
      ),
    });
  }

  return alertData;
}
